import { useLocation } from "react-router";

declare global {
  export interface Window {
    AuthAPI?: any;
  }
}

export function forwardMode(pathString: string, currentSearchString: string, otherParams: Record<any, any> = {}) {
  const currentParams = new URLSearchParams(currentSearchString);
  const mode = currentParams.get("mode");
  const newParams = new URLSearchParams(mode ? { ...otherParams, mode } : otherParams);
  return {
    pathname: pathString,
    search: newParams.toString(),
  };
}

export const useDetectApp = () => {
  const location = useLocation<any>();
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get("mode") === "app" || location.state?.mode === "app";
};

export function openWowAccountSettings() {
  window.open("ugg-app://ugg-wow/web/?settings=account");
}

export function appHandleToken(token: string) {
  if (window.AuthAPI) {
    window.AuthAPI.sendToken(token);
  } else {
    const appURL = `ugg-app://auth/web/${encodeURIComponent(token)}`;
    window.location.href = appURL;
  }
}
